<template lang='pug'>
  el-card.material-info(v-loading="loading")
    p.title {{ $t('素材信息') }}
    hr.divider
    template(
      v-if="isOpen"
    )
      .media-type-item(
        v-for="(item, index) in data.media_type"
      )
        p.media-type-item__title {{ $t('媒体形式') }} {{ index + 1 }}
        .title-row {{ $t('媒体形式') }}
        .content-row {{ item.media_type_category_name }}
        .target-audience-container(
          v-for="(v, idx) in data.media_type[index].media_type_target_audiences"
        )
          .title-row {{ $t('目标投放群体') }}
          .content-row {{ v.target_audiences_name }}
          .title-row {{ $t('素材上传') }}
          upload-img-container(
            :fileLists="fileLists"
            :index="index"
            :idx="idx"
            :data="data"
            @uploadSuccess="handleMaterialUploadSuccess"
            @onDelete="handleDeleteMaterial"
          )
        el-row(
          v-for="(v,idx) in data.media_type[index].media_type_qualify_info"
          :key="idx"
          :gutter="20"
        )
          el-col(
            style="width: 180px"
          ) {{ idx === 0 ? $t('资质信息') : ' ' }}
          el-col(
            style="display:flex;align-items:center"
            :span="10"
            :class="[idx !== 0 ? 'qualify-info-row' : '']"
          )
            el-select.qualify_selector(
              v-model="v.qualify_info_id"
              @change="(val) => {handleChangeQualify(val,v,index,idx)}"
              allow-create
              filterable
            )
              el-option(
                v-for="o, i in qualifyInfoLists[index][idx]"
                :key="i"
                :value="o.qualify_info_id"
                :disabled="!!data.media_type[index].media_type_qualify_info.find(item => item.qualify_info_id === o.qualify_info_id)"
                :label="o.qualify_info_name"
              )
            div(
              style="display: flex; align-items: center"
            )
              div(
                v-if="getQualifyInfoPath(v.qualify_info_id, index, idx) == '' ||  getQualifyInfo(v.qualify_info_id, index, idx).tmpOption"
                style="display: flex; align-items: center;margin-left: 10px"
              )
                new-upload-file(
                  style="margin-right: 5px"
                  axiosUrl="/management/subfinal/saveFile"
                  :params="{file_type: 21}"
                  @loadingChange="status => loading = status"
                  @uploadSuccess="(res) => {saveQualifyInfo(res, v, index, idx)}"
                )
                uploaded-file-display(
                  :fileName="v.file_name"
                  :downloadUrl="v.file_download_path"
                  :fileNameList="v.file_name_list"
                  width="95px"
                )
              a(
                v-else
                style="margin-left: 10px"
                :href="getQualifyInfoPath(item.media_type_qualify_info[idx].qualify_info_id, index, idx)"
              )  {{ getQualifyInfoName(item.media_type_qualify_info[idx].qualify_info_id, index, idx) }}
              el-button.delete_btn(
                style="margin-left: 14px"
                v-if="idx !== 0"
                type="text"
                @click="handleDeleteQualifyInfo(index, idx)"
              ) {{ $t('删除') }}
        el-row(
          :gutter="20"
        )
          el-col(
            :span="10"
            style="margin-left:180px"
          )
            el-button.add_btn(
              type="primary"
              plain
              icon="el-icon-circle-plus"
              @click='addNewQualify(index)'
            ) {{ $t('添加资质信息') }}
      .action-btn-group(
        v-if="isOpen"
      )
        el-button(
          @click="handleConfirm"
          type="primary"
        ) {{ $t('提交') }}
        el-button(
          @click="handleCancel"
        ) {{ $t('取消') }}
    template(
      v-else
    )
      .media-type-item(
        v-for="(item, index) in data.media_type"
      )
        p.media-type-item__title {{ $t('媒体形式') }} {{ index + 1 }}
        .title-row {{ $t('媒体形式') }}
        .content-row {{ item.media_type_category_name }}
        div(
          v-for="v in data.media_type[index].media_type_target_audiences"
        )
          .target-audience-container
            .title-row {{ $t('目标投放群体') }}
            .content-row {{ v.target_audiences_name }}
            .title-row(v-if="v.media_type_target_audiences_material.length !== 0")
              span {{ $t('素材') }}
              el-button(
                style="margin-left: 20px"
                @click="handleDownloadPack(v.media_type_target_audiences_id)"
                type="primary"
              ) {{ $t('打包下载') }}
            image-view-container(
              v-if="v.media_type_target_audiences_material.length !== 0"
              :items="v.media_type_target_audiences_material"
            )
            .content-row(v-else) —
        div(
          v-for="(o, idx) in data.media_type[index].media_type_qualify_info"
        )
          el-row(
            :gutter="20"
          )
            el-col(
              v-if="idx === 0"
              style="width: 180px"
            ) {{ $t('资质信息') }}
            el-col(
              :span="10"
              :class="[idx !== 0 ? 'qualify-info-row' : '']"
            )
              span(style="margin-right: 10px") {{ o.qualify_info_name }}
              a(
                :href="o.file_download_path"
              ) {{ o.file_name }}

    audit-versions(
      v-if="versions.length !== 0"
      :items="versions"
    )

</template>

<script>
import ImageViewContainer from '../components/ImageViewContainer'
import FooterButton from '@/components/FooterButton'
import axios from 'axios'
import NewUploadFile from '@/components/NewUploadFile'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'
import _ from 'lodash'
import { format4backend } from '@/umcc/util'
import AuditVersions from '../components/AuditVersions'
import { postfixToImgCode } from '@/umcc/constant'
import UploadImgContainer from '../components/UploadImgContainer'

export default {
  components: {
    ImageViewContainer,
    FooterButton,
    NewUploadFile,
    UploadedFileDisplay,
    AuditVersions,
    UploadImgContainer
  },
  data () {
    return {
      data: {
        media_type: [{
          media_type_target_audiences_material: [{}],
          media_type_qualify_info: [{}]
        }]
      },
      tmpQualifyInfoList: [],
      qualifyInfoLists: [[[]]],
      qualifyInfoList: [],
      loading: false,
      fileLists: [[[]], [[]]],
      versions: []
    }
  },
  computed: {
    campaignId () {
      return this.$store.state.campaign.id
    },
    ECTab () {
      return this.$store.state.campaign.ECTab
    },
    isOpen () {
      if (this.ECTab == null || this.ECTab.filter(i => i.tab_name === 'tab_material').length === 0) return false
      const res = this.$store.state.campaign.ECTab.filter(i => i.tab_name === 'tab_material')
      return res[0].is_open
    },
    taskId () {
      if (this.ECTab == null || this.ECTab.filter(i => i.tab_name === 'tab_material').length === 0) return null
      const res = this.$store.state.campaign.ECTab.filter(i => i.tab_name === 'tab_material')
      return res[0].task_id
    },
    subFinalScopeId () {
      return this.$store.state.campaign.subFinalScopeId
    }
  },
  async mounted () {
    if (this.ECTab == null || this.ECTab.filter(i => i.tab_name === 'tab_material').length === 0) {
      await this.$store.dispatch('campaign/updateECTab')
      if (this.campaignId) {
        this.getQualifyInfoList()
        this.getApproveHistory()
      }
    } else {
      if (this.campaignId) {
        this.getQualifyInfoList()
        this.getApproveHistory()
      }
    }
  },
  methods: {
    handleDownloadPack (id) {
      this.loading = true
      axios.get('/management/ec/downloadTAMaterial', {
        params: {
          media_type_target_audiences_id: id
        }
      })
        .then(res => {
          this.loading = false
          window.open(res.download_url, '_blank')
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    },
    getFileCover (url) {
      if (url.endsWith(('.pdf'))) {
        return postfixToImgCode.pdf
      } else if (url.endsWith('.mp4') || url.endsWith('.3gp') || url.endsWith('.avi') || url.endsWith('.mpeg')) {
        return postfixToImgCode.mp4
      } else if (url.endsWith('.xlsm') || url.endsWith('.xlsx')) {
        return postfixToImgCode.xlsx
      } else if (url.endsWith('.ppt')) {
        return postfixToImgCode.ppt
      } else if (url.endsWith('.doc')) {
        return postfixToImgCode.doc
      } else {
        return postfixToImgCode.other
      }
    },

    handleDownload (file) {
      window.open(file.url, '_blank')
    },

    handleDeleteMaterial (file, parentIndex, index) {
      const res = this.fileLists[parentIndex][index].filter(i => i.file_path !== file.file_path)
      this.$set(this.fileLists[parentIndex], index, res)
      this.data.media_type[parentIndex].media_type_target_audiences[index].media_type_target_audiences_material = res.map(i => {
        return {
          material_path: i.file_path
        }
      })
    },
    handleMaterialUploadSuccess (res, parentIndex, index) {
      this.$message.success(this.$t('提交成功'))

      if (this.fileLists[parentIndex][index] == null) {
        this.$set(this.fileLists[parentIndex], index, [])
      }

      this.fileLists[parentIndex][index].push({
        'name': res[0].file_name,
        'url': res[0].download_url,
        'file_path': res[0].file_path,
        'width': res.width,
        'height': res.height
      })
      this.data.media_type[parentIndex].media_type_target_audiences[index].media_type_target_audiences_material = this.fileLists[parentIndex][index].map(i => {
        return {
          material_path: i.file_path,
          width: i.width,
          height: i.height
        }
      })
      console.log('this.file', this.fileLists)
      console.log('haha', this.data)
    },

    getQualifyInfo (id, parentIndex, index) {
      if (typeof (id) === 'string' || id == null) {
        return {
          tmpOption: false
        }
      }
      return this.qualifyInfoLists[parentIndex][index].find(i => i.qualify_info_id === id)
    },

    getQualifyInfoPath (id, parentIndex, index) {
      if (typeof (id) === 'string') return ''
      if (id == null) return null
      return this.qualifyInfoLists[parentIndex][index].find(i => i.qualify_info_id === id).file_download_path
    },

    getQualifyInfoName (id, parentIndex, index) {
      if (typeof (id) === 'string') return ''
      if (id == null) return null
      return this.qualifyInfoLists[parentIndex][index].find(i => i.qualify_info_id === id).file_name
    },

    handleChangeQualify (val, item, parentIndex, index) {
      if (typeof (val) === 'string') return
      this.data.media_type[parentIndex].media_type_qualify_info[index].file_path = this.qualifyInfoLists[parentIndex][index].find(i => i.qualify_info_id === val).file_path
    },

    getSOW () {
      this.loading = true
      axios.get('/management/ec/getSOW', {
        params: {
          sub_final_scope_id: this.subFinalScopeId
        }
      })
        .then(res => {
          if (this.isOpen) {
            this.fileLists = res.media_type.map(i => {
              return i.media_type_target_audiences.map(o => {
                return o.media_type_target_audiences_material.map(item => ({
                  url: item.file_download_path,
                  file_path: item.material_path,
                  file_download_path: item.file_download_path,
                  height: item.height,
                  width: item.height
                }))
              })
            })

            res.media_type.map(i => {
              console.log('i', i.media_type_qualify_info)
              if (i.media_type_qualify_info == null || i.media_type_qualify_info.length === 0) {
                i.media_type_qualify_info = [{
                  media_type_id: i.media_type_id
                }]
              }
              return i
            })
            res.media_type.map(i => i.media_type_target_audiences.map(v => {
              if (v.media_type_target_audiences_material == null || v.media_type_target_audiences_material.length === 0) {
                v.media_type_target_audiences_material = [{
                  file_name: null,
                  file_download_path: null,
                  file_name_list: []
                }]
              }
            }))
            console.log('res', res)

            this.qualifyInfoLists = res.media_type.map(i => {
              return i.media_type_qualify_info.map(o => {
                const res = [...this.qualifyInfoList]
                if (o.qualify_info_id != null && !this.qualifyInfoList.find(i => i.qualify_info_id === o.qualify_info_id)) {
                  res.push({
                    qualify_info_id: o.qualify_info_id,
                    qualify_info_name: o.qualify_info_name,
                    tmpOption: true
                  })
                }
                return [...res]
              })
            })
          }
          console.log('haha', this.qualifyInfoLists)
          this.data = res
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    },
    async handleConfirm () {
      let isValid = true
      for (let i = 0; i < this.data.media_type.length; i++) {
        const categoryName = this.data.media_type[i].media_type_category_name
        if (categoryName !== 'RTB-超级推荐' && categoryName !== 'CPD-资源包' && categoryName !== 'RTB-付费搜索' && categoryName !== '淘宝客/京挑客') {
          for (let j = 0; j < this.data.media_type[i].media_type_target_audiences.length; j++) {
            for (let v = 0; v < this.data.media_type[i].media_type_target_audiences[j].media_type_target_audiences_material.length; v++) {
              if (this.data.media_type[i].media_type_target_audiences[j].media_type_target_audiences_material.length === 0) {
                isValid = false
                break
              }
              let item = this.data.media_type[i].media_type_target_audiences[j].media_type_target_audiences_material[v]
              if (item.material_path == null || item.material_path === '') {
                isValid = false
                break
              }
            }
          }
        }
      }
      if (!isValid) {
        this.$message.error(this.$t('请上传素材'))
        return
      }
      const params = {
        task_id: this.taskId,
        sub_final_scope_id: this.subFinalScopeId,
        media_type_target_audiences_material: _.flatten(_.flatten(this.data.media_type.map(i => i.media_type_target_audiences))
          .map(o => o.media_type_target_audiences_material.map(v => {
            if (v.material_path != null) {
              const res = {
                media_type_target_audiences_id: o.media_type_target_audiences_id,
                material_path: v.material_path,
                width: v.width,
                height: v.height
              }
              return _.pickBy(res, v => v != null && v !== '')
            }
          }))),
        media_type_qualify_info: _.flatten(this.data.media_type.map(i => i.media_type_qualify_info)).map(v => {
          const res = {
            media_type_id: v.media_type_id,
            qualify_info_id: v.qualify_info_id,
            file_path: v.file_path
          }
          if (res.qualify_info_id != null) {
            return res
          }
        })
      }

      this.loading = true
      try {
        const res = await axios.post('/management/ec/uploadMaterial', format4backend(params))
        await this.$store.dispatch('campaign/updateECTab')
        this.loading = false
        this.data = res
        this.$message.success(this.$t('提交成功'))
      } catch (err) {
        this.loading = false
        throw new Error(err)
      }
    },
    getQualifyInfoList () {
      axios.get('/management/ec/getQualifyInfoList')
        .then(res => {
          this.qualifyInfoList = res
          this.getSOW()
        })
        .catch(err => {
          throw new Error(err)
        })
    },

    addNewQualify (i) {
      this.data.media_type[i].media_type_qualify_info.push({
        media_type_id: this.data.media_type[i].media_type_id,
        qualify_info_id: null,
        qualify_info_name: ''
      })
      this.qualifyInfoLists[i].push([...this.qualifyInfoList])
    },

    saveQualifyInfo (res, item, parentIndex, index) {
      const params = {
        qualify_info_name: item.qualify_info_id,
        file_path: res.file_path
      }
      if (typeof (item.qualify_info_id) !== 'string') {
        params.qualify_info_id = item.qualify_info_id
        params.qualify_info_name = item.qualify_info_name
      }
      axios.get('/management/ec/saveQualifyInfo', {
        params: params
      })
        .then(res => {
          res.tmpOption = true
          this.qualifyInfoLists[parentIndex][index].push(res)
          this.data.media_type[parentIndex].media_type_qualify_info[index].qualify_info_id = res.qualify_info_id
          this.data.media_type[parentIndex].media_type_qualify_info[index].qualify_info_name = res.qualify_info_name
          this.data.media_type[parentIndex].media_type_qualify_info[index].file_path = res.file_path
          this.data.media_type[parentIndex].media_type_qualify_info[index].file_download_path = res.file_download_path
          this.data.media_type[parentIndex].media_type_qualify_info[index].file_name = res.file_name
        })
        .catch(err => {
          throw new Error(err)
        })
    },

    getApproveHistory () {
      axios.get('/management/subfinal/getMoreApproveHistory', {
        params: {
          id: this.$store.state.campaign.subFinalScopeId,
          audit_type: '25,29'
        }
      })
        .then(res => {
          this.versions = res
        })
        .catch(err => {
          throw new Error(err)
        })
    },

    handleDeleteQualifyInfo (parentIndex, index) {
      this.data.media_type[parentIndex].media_type_qualify_info.splice(index, 1)
    },

    handleCancel () {
      this.$router.push('/ec-campaign/overview')
    }
  }
}
</script>

<style lang='stylus'>
.material-info
  .media-type-item__title
    margin-bottom 24px
  .title-row
    color #999999
  .content-row
    color #5e5e5e
    margin 12px 0 24px
  .footer-button
    margin-left 180px
  .target-audience-container
    border 1px dashed #d8d8d8
    padding 24px
    width 650px
    margin-bottom 24px
  .upload-image-container
    margin-top 12px
  .action-btn-group
    width 650px
    display flex
    justify-content flex-end
    margin-top 32px
    margin-left 50px
    .el-button--text
      color #808080
    .el-button--default
      color #979797
      border-color #979797
      background #ffffff

  .qualify_selector
    .el-input
      width 180px

  .qualify-info-row
    margin-left 180px
  .add_btn
    margin-left 0
    padding-left 0
    padding-right 0
    color $main !important
    border-color #ffffff !important
    background #ffffff  !important
    &:hover
      color $main !important

  .delete_btn
    color #f66c62
    &:hover
      color #f66c62 !important
</style>
